export enum ViewType {
  CREATING = "creating",
  EDITING = "editing",
  LISTING = "list"
}
